var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 17.738C3 25.051 8.95 31 16.262 31c7.312 0 13.261-5.95 13.261-13.262 0-7.164-8.686-16.189-9.056-16.569a.552.552 0 0 0-.781-.011.552.552 0 0 0-.011.78c.02.022 2.23 2.304 4.406 5.4 2.844 4.047 4.344 7.64 4.344 10.398 0 6.71-5.452 12.163-12.162 12.163-6.71 0-12.163-5.462-12.163-12.162 0-2.758 1.489-6.35 4.31-10.398 2.156-3.096 4.343-5.378 4.365-5.4a.552.552 0 0 0-.01-.781.552.552 0 0 0-.783.01c-.095.094-2.261 2.356-4.47 5.526C4.522 10.996 3 14.716 3 17.738zm13.262 10.62c-6.013 0-10.895-4.892-10.895-10.895 0-5.875 8.2-14.075 8.549-14.413a.562.562 0 0 1 .782 0 .562.562 0 0 1 0 .782c-.085.085-8.221 8.221-8.221 13.631 0 5.4 4.396 9.796 9.795 9.796 5.4 0 9.796-4.397 9.796-9.797 0-2.218-1.437-5.283-4.164-8.886-2.074-2.735-4.16-4.815-4.215-4.87l-.002-.002a.542.542 0 0 1 0-.782.542.542 0 0 1 .782 0c.36.349 8.708 8.655 8.708 14.54-.022 6.003-4.904 10.895-10.916 10.895zm0-2.642c-4.555 0-8.253-3.698-8.253-8.253-.001-4.427 7.47-12.247 7.787-12.574l.39-.413.402.401c.327.328 7.925 8.147 7.925 12.575 0 4.565-3.699 8.264-8.253 8.264zm-.064-19.644a56.632 56.632 0 0 0-3.392 4.037c-2.42 3.19-3.698 5.726-3.698 7.343 0 3.942 3.212 7.154 7.154 7.154 3.941 0 7.154-3.212 7.154-7.154 0-1.617-1.3-4.153-3.762-7.344a58.752 58.752 0 0 0-3.456-4.038z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrm);
export default __webpack_public_path__ + "static/media/SRM.487af08d4311056bbd524dcdfdd22660.svg";
export { ForwardRef as ReactComponent };